import styled from "styled-components";

import {
  alignItemsCenter,
  circle,
  flexCenter,
  flexColumn,
  rem,
} from "@styles/Utilities.styled";


export const StyledAnalysisTestsModalContent = styled.div`
  ${flexColumn}
  gap: 1.5rem;

  .grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 1rem;
  }
`;

export const StyledLabCard = styled.div`
  ${alignItemsCenter}
  gap: 0.5rem;

  .icon-wrapper {
    ${flexCenter}
    background-color: var(--clr-accent);
    color: var(--clr-white);
    ${circle(rem(40))}
    min-width: ${rem(40)}
  }
`;
